import { gql } from '@apollo/client';

import { FragmentDealer } from '../fragments/dealer';

export const QuerySearchDealers = gql`
  query SearchDealers($filter: SearchDealersFilterInput, $limit: Int) {
    searchDealers(filter: $filter, limit: $limit) {
      ...FragmentDealer
      accessoryDealerId
    }
  }
  ${FragmentDealer}
`;

export const QuerySearchConfigurableCarsDealers = gql`
  query SearchConfigurableCarsDealers(
    $filter: SearchConfigurableCarsDealersFilterInput
    $limit: Int
  ) {
    searchConfigurableCarsDealers(filter: $filter, limit: $limit) {
      ...FragmentDealer
      accessoryDealerId
    }
  }
  ${FragmentDealer}
`;
